module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptit"
  }, [_c('b', [_vm._v("Maps and Sidebars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('b', [_vm._v("Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/cha03#map1"
    }
  }, [_vm._v("1.  The Western Front")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/cha03#map2"
    }
  }, [_vm._v("2.  The Eastern Front")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/cha03#map3"
    }
  }, [_vm._v("3.  Mesopotamia and Persia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha04#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.  Gallipoli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha04#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.  Egypt, Palestine, and Syria")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha08#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.  The Western Front (Armistice)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('b', [_vm._v("Sidebars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/cha03#box-1"
    }
  }, [_vm._v("Naval Strength at the Beginning of the War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/cha03#box-2"
    }
  }, [_vm._v("Population and Military Strength at the Beginning of the War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/cha03#box-3"
    }
  }, [_vm._v("Infantry Tactics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha04#box-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trench Warfare")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha04#box-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poison Gas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha04#box-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Machine Guns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha04#box-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Propaganda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha04#box-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Airplanes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha04#box-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artillery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha05#box-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tanks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha05#box-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naval Warfare")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha05#box-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communcations and Command Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha05#box-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Air Aces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha06#box-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Submarines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha06#box-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mutinies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha06#box-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Songs of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha07#box-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Human Costs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cha08#box-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Literature of War")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e64fe47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc1.vue
// module id = 72
// module chunks = 0